let tabSelected = [true,false,false]
class TabbedContent {
    constructor(el) {
        if(el.id !== 'radioTab') {
            loadSwitchCase()
            this.refreshScope(el);
            this.index = 0;
            let indexOfTabActive = tabSelected.indexOf(true)
            switch (indexOfTabActive) {
                case 0:
                    this.index = 0;
                    break;
                case 1:
                    this.index = 1;
                    break;
                case 2:
                    this.index = 2;
            }

            this.el
                .querySelector(".m-tabbedContent__tabs")
                .addEventListener(
                    "MDCTabBar:activated",
                    this.handleTabs.bind(this)
                );
            this.displayAllAgentContent();
            this.update();
            this.livewireHooks();
        }
    }
    update() {
        const index = this.index;
        this.items().forEach((item, i) => {
            item.dataset.hidden = +(i !== index);
        });
    }
    livewireHooks() {
        var $this = this;
        Livewire.hook('message.processed', function(el) {
            if (el.component.el.querySelector(".m-tabbedContent__tabs")) {
                $this.update();
                $this.refreshScope(this.el);
                $this.restoreActiveTab();
            }
        });
    }
    handleTabs(e) {
        this.index = e.detail.index;
        this.update();
    }
    restoreActiveTab() {
        this.mdc.TabBar.activateTab(this.index);
    }
    displayAllAgentContent() {
        if(window.location.toString().includes("allagents")) {
            this.index = 1;
        }
    }
    refreshScope(el) {
        this.el = el || this.el;
        this.tabBarEl = this.el.querySelector('.mdc-tab-bar');
        this.mdc = {
            TabBar: this.tabBarEl.MDCTabBar, foundation: this.tabBarEl.MDCTabBar.foundation, adapter: this.tabBarEl.MDCTabBar.foundation.adapter
        };
    }
    items() {
        return Array.from(this.el.children).filter((e) =>
            e.matches(".m-tabbedContent__item")
        );
    }
}
document.addEventListener("MDCAutoInit:End", function () {
    Array.from(document.querySelectorAll(".m-tabbedContent")).forEach(
        (item) => new TabbedContent(item)
    );
    window.Livewire.hook('message.processed', function(el) {
        var liveWireTabs = el.component.el.querySelectorAll('.m-tabbedContent');
        if (liveWireTabs.length) {
            Array.from(liveWireTabs).forEach(function(field) {
                new TabbedContent(field);
            });
        }
    });
});


function loadSwitchCase() {
    let tabs = Array.from(document.getElementsByClassName('mdc-tab'))
    tabs.forEach((item, i) => {
            item.addEventListener('click', function() {
                switch(i) {
                    case 0:
                        tabSelected = [true, false, false]
                        break;
                    case 1:
                        tabSelected = [false, true, false]
                        break;
                    case 2:
                        tabSelected = [false, false, true]
                        break;
                }
            })
        }
    );
}

document.addEventListener("MDCAutoInit:End", function () {
    Array.from(document.querySelectorAll(".m-tabbedContent")).forEach(
        (item) => new TabbedContent(item)
    );
    window.Livewire.hook('message.processed', function(el) {
        var liveWireTabs = el.component.el.querySelectorAll('.m-tabbedContent');
        if (liveWireTabs.length) {
            Array.from(liveWireTabs).forEach(function(field) {
                new TabbedContent(field);
            });
        }
    });
});

class OfferFromTabbedContent
{
    constructor(el, update)
    {
        if(el.id === 'radioTab') {
            this.el = el;
            this.index = 1;
            this.el.querySelector('.m-tabbedContent__tabs')
                .addEventListener('MDCTabBar:activated', this.handleTabs.bind(this));
            if (update === 0) {
                this.items().forEach((item, i) => {
                    item.dataset.hidden = 1;
                });
            }
            this.hideRadioScroller();
        }
    }

    hideRadioScroller() {
        var tabScroller = document.querySelector('.mdc-tab-scroller');
        if (tabScroller !== null && tabScroller.classList.contains('mdc-tab-scroller')) {
            tabScroller.classList = 'mdc-tab-scrollers';
        }
        var rbiRadioTab = document.getElementsByName('building_and_pest');
        if(rbiRadioTab.item(0).childNodes.item(1).classList.contains('mdc-tab-scroller')) {
            rbiRadioTab.item(0).childNodes.item(1).classList = 'mdc-tab-scrollers';
        }

    }


    update()
    {
        const index = this.index;
        this.items().forEach((item, i) => {
            item.dataset.hidden = +(i !== index);
        });
    }

    handleTabs(e)
    {

        const tabBar = this.el.querySelector('.mdc-tab-bar');
        if(tabBar.classList.contains('has-error')) {
            tabBar.classList.remove('has-error');
        }

        const selectedTab = e.target.getAttribute('name');
        if(selectedTab === 'conveyancer') {
            Livewire.emit('conveyancerClicked', e.detail.index);
        }
        if(selectedTab === 'building_and_pest') {
            Livewire.emit('rbiClicked', e.detail.index);
        }
        this.index = e.detail.index;
        this.update();
    }

    items()
    {
        return Array.from(this.el.children).filter(e => e.matches('.m-tabbedContent__item'));
    }
}

window.addEventListener('DOMContentLoaded', function() {
    Array.from(document.querySelectorAll('.m-tabbedContent'))
        .forEach((item) => new OfferFromTabbedContent(item, 0));
});

document.addEventListener("MDCAutoInit:End", function () {
    Array.from(document.querySelectorAll(".m-tabbedContent")).forEach(
        (item) => new OfferFromTabbedContent(item, 1)
    );
});


window.addEventListener("oto.editOffer", function (e) {
    const offer = e.detail.offer;
    const ccaIndex = offer.conveyancer === true ? 0 : 1;
    const rbiIndex = offer.buildingAndPest === true ? 0 : 1;
    //id ConveyancerTab -> yes / ConveyancerTabTwo -> no ---- RbiTab -> yes / RbiTabTwo -> no
    const ccaTab1 = document.getElementById('ConveyancerTab');
    const ccaTab2 = document.getElementById('ConveyancerTabTwo');
    const ccaArray = [ccaTab1, ccaTab2];
    ccaArray.forEach((item, i) => {
        item.dataset.hidden = +(i !== ccaIndex);
    });

    const rbiTab1 = document.getElementById('RbiTab');
    const rbiTab2 = document.getElementById('RbiTabTwo');
    const RbiArray = [rbiTab1, rbiTab2];
    RbiArray.forEach((item, i) => {
        item.dataset.hidden = +(i !== rbiIndex);
    });
});

